/** Inbox/CRM customer call lists: smaller pages for incremental "load more" UX (API default is 25). */
export const CUSTOMER_CALLS_PAGE_SIZE = 10;
